import { render, staticRenderFns } from "./TruckingMovementUpdate.vue?vue&type=template&id=6048dd64&scoped=true&"
import script from "./TruckingMovementUpdate.vue?vue&type=script&lang=js&"
export * from "./TruckingMovementUpdate.vue?vue&type=script&lang=js&"
import style0 from "./TruckingMovementUpdate.vue?vue&type=style&index=0&id=6048dd64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6048dd64",
  null
  
)

export default component.exports